import * as React from 'react';
import {useSelector} from 'react-redux';

import {selectEntityMappingsBySenseName} from 'src/selectors/ats-entities';
import classify from 'src/utils/classify';

import {FilterCard} from 'src/components/lib/analytics-filter-card/index';
import Checkbox from 'src/components/lib/checkbox/index';

import css from './calendar-status.css';

import useI18n from 'src/hooks/useI18n';


type Props = {
  onSave?: (e: React.SyntheticEvent) => unknown;
  onCancel?: (e: React.SyntheticEvent) => unknown;
  onFilterCalendarStatusTypeChange: (
    e: React.SyntheticEvent<HTMLInputElement>,
  ) => unknown;
  selectedFilterCalendarStatusTypes: string[];
  filterCalendarStatusTypes?: {
    value: string;
    label: string;
    sense_name: string;
  }[];
};

const filterCalendarStatusTypesLocal = [
  {
    value: 'connected',
    label: 'Connected',
  },
  {
    value: 'not_connected',
    label: 'Not Connected',
  },
  {
    value: 'not_invited',
    label: 'Not yet invited',
  },
];

const getTranslatedFilterCalendarStatusTypes = (labelI18nInstance: any) => {
  const defaultFilterCalendarStatusTypes = [
    {
      value: 'connected',
      label: labelI18nInstance.t('Connected', 'Connected'),
      sense_name: 'connected',
    },
    {
      value: 'not_connected',
      label: labelI18nInstance.t('Not_Connected', 'Not Connected'),
      sense_name: 'not_connected',
    },
    {
      value: 'not_invited',
      label: labelI18nInstance.t('Not_yet_invited', 'Not yet invited'),
      sense_name: 'not_invited',
    },
  ];
  return defaultFilterCalendarStatusTypes;
};

const FilterCalendarStatusCard = ({
  onSave,
  onCancel,
  filterCalendarStatusTypes,
  onFilterCalendarStatusTypeChange,
  selectedFilterCalendarStatusTypes = [],
  // @ts-expect-error - TS2339 - Property 'cardLabel' does not exist on type 'Props'.
  cardLabel = 'Filter Calendar Status',
}: Props) => {
  const {labelI18nInstance} = useI18n();
  const filteredFilterCalendarStatusTypes =
    filterCalendarStatusTypes ||
    filterCalendarStatusTypesLocal ||
    getTranslatedFilterCalendarStatusTypes(labelI18nInstance);

  return (
    <FilterCard header={cardLabel} onSave={onSave} onCancel={onCancel}>
      <section className={css.section}>
        <ul className={css.checklist}>
          {filteredFilterCalendarStatusTypes.map(({value, label}) => (
            <li key={value}>
              <label className={classify(css.label, css[value])}>
                <Checkbox
                  className={css.checkbox}
                  name={value}
                  checked={selectedFilterCalendarStatusTypes.includes(value)}
                  onChange={onFilterCalendarStatusTypeChange}
                />
                {label}
              </label>
            </li>
          ))}
        </ul>
      </section>
    </FilterCard>
  );
};

export default FilterCalendarStatusCard;
